import { NoValue } from 'components/no_value/NoValue';

export function SerialNumber({
    value,
    className,
    fallbackOverride,
}: {
    value: string | undefined;
    className?: string;
    fallbackOverride?: JSX.Element | undefined;
}): JSX.Element {
    if (value === undefined) {
        return fallbackOverride ?? <NoValue />;
    }
    if (value.trim() === '') {
        return <>BLANK SERIAL NUMBER</>;
    }
    return (
        <code className={className} title={value}>
            {value}
        </code>
    );
}
